// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"315":"f6810c17","367":"075da6ff"}[chunkId] + ".js";
};